<template>
  <b-container fuid>
    <b-modal id="modal-consignee-list" title="Consignee List" @ok="handleOk" @cancel="handleCancel">
      <b-input-group class="pb-2">
        <b-form-input class="mr-sm-2" placeholder="Consignee" v-model="critere" @keyup.enter="get_consignee_list"/>
        <b-input-group-append>
          <b-button variant="outline-success" @click="get_consignee_list">SEARCH</b-button>
        </b-input-group-append>
      </b-input-group>
      <b-table
        v-if="rows > 0"
        id="table-consignee-list"
        primary-key="id"
        striped
        hover
        outlined
        table-variant="warning"
        head-variant="danger"
        :items="consignee_list"
        :fields="unit_fields"
        :per-page="perPage"
        :current-page="currentPage"
        selectable
        select-mode="single"
        @row-selected="onRowSelected"
      >
      <!--
        <template v-slot:cell(id)="data">
          <input type="radio" name="selected_consignee" :value="data.value" v-model="consignee_id" />
        </template>
      -->
      </b-table>
      <b-pagination
        v-show="rows > perPage"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
      <template v-slot:modal-footer="{ ok, cancel }">
        <!--
        <b-button variant="success" @click="ok()">OK</b-button>
        -->
        <b-button variant="danger" @click="cancel()">Cancel</b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { mapState } from "vuex";
import { eventBus } from "@/main";

export default {
  name: "modal-consignee-list",
  data() {
    return {
      critere: "",
      perPage: 10,
      currentPage: 1,
      consignee_id: 0,
      unit_fields: [
        { key: "id", label: "id" },
        { key: "name", label: "Name", sortable: true }
      ]
    };
  },
  computed: {
    ...mapState(["consignee_list"]),
    rows() {
      return this.consignee_list.length;
    }
  },
  methods: {
    onRowSelected(items) {
      this.consignee_id = items[0].id;
      this.handleSubmit();
    },
    get_consignee_list(bvModalEvt) {
      bvModalEvt.preventDefault();
      let choicelist = true;
      let customer_name = this.critere;
      this.$store.dispatch("get_consignee_list",{
        choicelist,
        customer_name
      });
    },
    handleCancel() {
      this.consignee_id = 0;
      this.$nextTick(() => {
        this.$bvModal.hide(this.name);
      });
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      //this.handleSubmit();
    },
    handleSubmit() {
      eventBus.$emit("consignee_was_selected_from_modal", this.consignee_id);
      this.$nextTick(() => {
        this.$bvModal.hide("modal-consignee-list");
      });
    }
  }
};
</script>

<style scoped>
div {
  color: red;
}
</style>
